import { render, staticRenderFns } from "./PaxelMarketPartners.vue?vue&type=template&id=3112fc62&"
import script from "./PaxelMarketPartners.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports